export const isValidEmail = function (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isValidPassword = function (password) {
  return /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\^$*.[\]{}\(\)\?"!@#%\/\\&,><':;\|_~`=\+-])(?=.{12,})/.test(
    password,
  );
};

export const isValidZipcode = function () {
  // TODO: Add more robust zip/postal-code validation
  return true;
};
